import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../user-service/user.service';

const TOKEN_KEY = 'edash_auth_token';

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  public authenticationState = new BehaviorSubject(false);

  constructor(
    private userService: UserService,
    private cookieService: CookieService,
    private router: Router
    ) { }
  
  /**
   * check jwt
   */
  public checkToken() {
    const token = this.userService.getToken();
    if (token) {
      this.authenticationState.next(true);
    }
  }

  /**
   * Save jwt & user in cookies,
   * return in Authentication header for every subsequent call
   */
  public async login(token: string) {  
    this.cookieService.set(TOKEN_KEY, token, undefined, undefined, undefined, true);
    
    const user = this.parseJwt(token);
    this.userService.saveUser(user);
      
    this.authenticationState.next(true);
  }

  /**
   * Return user token
   */
  public getToken(): string {
    return this.userService.getToken();
  }
  /**
   * Log user out
   */
  public logout() {
    this.userService.deleteTokens();
    this.authenticationState.next(false);
    this.router.navigateByUrl('/login');
  }

  /**
   * Parse JWT for user data
   * @param token
   * JWT string
   */
     public parseJwt(token: string) {    
      const base64Url = token.split('.')[1];
        
      if (base64Url) {
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(
          decodeURIComponent(
            atob(base64)
              .split('')
              .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
              .join('')
          )
        );
  
      }
    }

  /**
   * Gets auth status of user
   */
  public isAuthenticated() {
    return this.cookieService.get(TOKEN_KEY) || this.authenticationState.value;
  }
}
